/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetCategoryDto interface.
 */
export function instanceOfGetCategoryDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function GetCategoryDtoFromJSON(json) {
    return GetCategoryDtoFromJSONTyped(json, false);
}
export function GetCategoryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
export function GetCategoryDtoToJSON(json) {
    return GetCategoryDtoToJSONTyped(json, false);
}
export function GetCategoryDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
    };
}
